'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactDates = require('react-dates');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdvancedSearch = function AdvancedSearch(props) {
	return _react2.default.createElement(
		'div',
		{ className: _style2.default.advancedMenu + ' ' + (props.showAdvancedOptions ? _style2.default.active : '') },
		_react2.default.createElement(
			'ul',
			{ className: _style2.default.advancedOptionsList },
			_react2.default.createElement(
				'li',
				{ className: _style2.default.advancedOption,
					onClick: function onClick() {
						props.selectAdvancedOption('date');
					} },
				_react2.default.createElement('i', { className: 'ion-ios-calendar-outline' }),
				_react2.default.createElement(
					'span',
					null,
					'Date'
				),
				_react2.default.createElement('i', { className: 'ion-ios-arrow-right' })
			),
			_react2.default.createElement(
				'li',
				{ className: _style2.default.advancedOption,
					onClick: function onClick() {
						props.selectAdvancedOption('gender');
					} },
				_react2.default.createElement('i', { className: 'ion-transgender' }),
				_react2.default.createElement(
					'span',
					null,
					'Gender'
				),
				_react2.default.createElement('i', { className: 'ion-ios-arrow-right' })
			),
			_react2.default.createElement(
				'li',
				{ className: _style2.default.advancedOption,
					onClick: function onClick() {
						props.selectAdvancedOption('language');
					} },
				_react2.default.createElement('i', { className: 'ion-ios-world-outline' }),
				_react2.default.createElement(
					'span',
					null,
					'Language'
				),
				_react2.default.createElement('i', { className: 'ion-ios-arrow-right' })
			),
			_react2.default.createElement(
				'li',
				{ className: _style2.default.advancedOption,
					onClick: function onClick() {
						props.selectAdvancedOption('sortby');
					} },
				_react2.default.createElement('i', { className: 'ion-android-funnel' }),
				_react2.default.createElement(
					'span',
					null,
					'Sort By'
				),
				_react2.default.createElement('i', { className: 'ion-ios-arrow-right' })
			)
		),
		_react2.default.createElement(
			'div',
			{ className: _style2.default.selectedAdvancedOptionMenu + ' ' + (props.selectedAdvancedOption === 'date' ? _style2.default.active : '') },
			_react2.default.createElement(_reactDates.SingleDatePicker, {
				date: (0, _moment2.default)(),
				onDateChange: function onDateChange(date) {
					return props.dateSelected(date);
				},
				focused: props.dateFocused,
				onFocusChange: function onFocusChange(focused) {
					return props.dateFocusChange(focused);
				},
				numberOfMonths: 1,
				hideKeyboardShortcutsPanel: true,
				showDefaultInputIcon: true,
				customInputIcon: _react2.default.createElement('i', { className: 'ion-ios-calendar-outline' }),
				keepOpenOnDateSelect: false,
				displayFormat: 'll'
			}),
			_react2.default.createElement(
				'button',
				{ className: _style2.default.advancedOptionButton },
				'Today'
			),
			_react2.default.createElement(
				'button',
				{ className: _style2.default.advancedOptionButton },
				'Tomorrow'
			),
			_react2.default.createElement(
				'button',
				{ className: _style2.default.advancedOptionButton },
				'This Week'
			)
		),
		_react2.default.createElement(
			'div',
			{ className: _style2.default.selectedAdvancedOptionMenu + ' ' + (props.selectedAdvancedOption === 'gender' ? _style2.default.active : '') },
			_react2.default.createElement(
				'button',
				{ className: _style2.default.advancedOptionButton,
					onClick: function onClick() {
						props.onGenderSelected('m');
					} },
				'Male'
			),
			_react2.default.createElement(
				'button',
				{ className: _style2.default.advancedOptionButton,
					onClick: function onClick() {
						props.onGenderSelected('f');
					} },
				'Female'
			)
		),
		_react2.default.createElement(
			'div',
			{ className: _style2.default.selectedAdvancedOptionMenu + ' ' + (props.selectedAdvancedOption === 'language' ? _style2.default.active : '') },
			_react2.default.createElement(
				'ul',
				null,
				props.languages.map(function (language) {
					return _react2.default.createElement(
						'li',
						{ className: '' + _style2.default.refineCategoryOption,
							onClick: function onClick() {
								props.onLanguageSelected(language);
							} },
						_react2.default.createElement(
							'span',
							null,
							language
						)
					);
				})
			)
		),
		props.selectedAdvancedOption === 'sortby' && _react2.default.createElement(
			'div',
			{ className: _style2.default.selectedAdvancedOptionMenu },
			_react2.default.createElement(
				'div',
				{ className: _style2.default.sortByOption },
				_react2.default.createElement(
					'span',
					null,
					'Relevance'
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.sortByOption },
				_react2.default.createElement(
					'span',
					null,
					'Rating'
				)
			)
		)
	);
};

exports.default = AdvancedSearch;


var noop = function noop() {};

AdvancedSearch.defaultProps = {
	// selectedAdvancedOption: 'sortby',
	dateSelected: noop,
	dateFocusChange: noop,
	dateFocused: true,
	languages: [{
		name: 'English'

	}]
};


// WEBPACK FOOTER //
// ./components/mobile-search-menu/lib/components/advanced-search.js